import { createContext, useContext } from 'react';
export const FocusOnContext = /*#__PURE__*/createContext(false);
export const useFocusOnContext = () => useContext(FocusOnContext);